// extracted by mini-css-extract-plugin
export default {"container":"radioBalloon_container__v2Yn4","label":"radioBalloon_label__Qoqn1"};